import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Container, Paper, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router';
import { signOutUnauthorizedUser } from '../../firebase/auth';
import { auth } from '../../firebase/firebaseConfig';

const AccessDenied: React.FC = () => {
  const navigate = useNavigate();
  const [isSigningOut, setIsSigningOut] = useState(true);

  useEffect(() => {
    // Check if there's an actual user to sign out
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      unsubscribe();
      if (user) {
        console.log("Access denied page: Found user to sign out", user.email);
        setIsSigningOut(true);
        try {
          await signOutUnauthorizedUser();
          console.log("Access denied page: User signed out successfully");
        } catch (error) {
          console.error("Access denied page: Error signing out user", error);
        }
      } else {
        console.log("Access denied page: No user to sign out");
      }
      setIsSigningOut(false);
    });

    return () => unsubscribe();
  }, []);

  const handleBackToSignIn = () => {
    navigate('/sign-in', { replace: true });
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper 
        elevation={3} 
        sx={{ 
          py: 4, 
          px: 4, 
          display: 'flex', 
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom>
          No Access
        </Typography>
        <Box sx={{ my: 2 }}>
          <Typography variant="body1" align="center" color="text.secondary">
            You don't have permission to access this page.
            Please contact support if you believe this is an error.
          </Typography>
        </Box>
        {isSigningOut ? (
          <Box sx={{ my: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <CircularProgress size={24} sx={{ mb: 1 }} />
            <Typography variant="body2" color="text.secondary">
              Signing out...
            </Typography>
          </Box>
        ) : (
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleBackToSignIn}
            sx={{ mt: 2 }}
          >
            Back to Sign In
          </Button>
        )}
      </Paper>
    </Container>
  );
};

export default AccessDenied;
